<template>
  <div>
    <base-modal
      :showing="visible"
      size="max-w-6xl"
      @opened="onOpened"
      @close="$emit('close')"
    >
      <div class="space-y-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div>
              <h3 class="text-lg font-bold leading-6 text-gray-900">
                Daftar Barang
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Daftar Barang Yang Telah Ditambahkan
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-4 border-t border-gray-200 pt-6">
          <div class="flex justify-end gap-x-2">
            <base-input
              placeholder="Cari Barang"
              type="search"
              :shadow="false"
              debounce
              v-model="filter.search"
              @native-input="loadProducts"
            />
          </div>
          <datatable
            :columns="tableColumns"
            :scroll-x="false"
            :total="products.meta.page.total"
            :perPage="products.meta.page.perPage"
            :currentPage="products.meta.page.currentPage"
            @pagechanged="onPagechanged"
          >
            <template v-slot:tbody="{ classes }">
              <tr
                v-for="product in products.data"
                :key="product.id"
                :class="[
                  classes.tr,
                  'cursor-pointer bg-white hover:bg-green-100',
                ]"
                @click="onClickProduct(product)"
              >
                <td :class="[classes.td]">
                  <p class="font-bold text-gray-900">
                    {{ product.attributes.code }}
                  </p>
                </td>
                <td :class="[classes.td]">
                  {{ product.attributes.name }}
                </td>
                <td :class="[classes.td]">
                  {{ product.attributes.product_category_name }}
                </td>
                <td :class="[classes.td]">
                  {{ product.attributes.unit_name }}
                </td>
                <td :class="[classes.td, 'text-right']">
                  {{ product.attributes.supplier_price | toCurrency }}
                </td>
                <td :class="[classes.td, 'text-right']">
                  {{ product.attributes.supplier_free_price | toCurrency }}
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal';
import { requestMixin } from '@/mixins/request/request';

export default {
  components: {
    BaseModal,
  },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    requestParams: null,
    officeId: String,
  },
  emits: ['close', 'click-product'],
  data() {
    return {
      products: {
        data: [],
        meta: {
          page: {},
        },
      },
      loading: false,
      filter: {
        search: null,
      },
    };
  },
  computed: {
    tableColumns() {
      return [
        {
          id: 'code',
          name: 'Kode Barang',
        },
        {
          id: 'name',
          name: 'Nama Barang',
        },
        {
          id: 'product_category',
          name: 'Kelompok Produk',
        },
        {
          id: 'unit',
          name: 'Unit',
        },
        {
          id: 'supplier_price',
          name: 'Harga Supplier',
          theadClass: 'text-right',
        },
        {
          id: 'supplier_price_promo',
          name: 'Harga Supplier Promo',
          theadClass: 'text-right',
        },
      ];
    },
  },
  methods: {
    async loadProducts(params) {
      this.loading = true;

      const [res, error] = await this.request(
        `/api/v1/offices/${this.officeId}/products`,
        {
          params: {
            ...this.requestParams,
            'page[size]': 5,
            'filter[search]': this.filter.search,
            'fields[products]':
              'code,name,product_category_name,unit_name,supplier_price,supplier_free_price',
            ...params,
          },
        }
      );

      if (!error) {
        this.products = res;
      }

      this.loading = false;
    },
    onClickProduct(product) {
      this.$emit('click-product', product);
    },
    onOpened() {
      this.filter.search = null;

      this.loadProducts();
    },
    onPagechanged(page) {
      this.loadProducts({
        'page[number]': page,
      });
    },
  },
};
</script>
